import { render, staticRenderFns } from "./Notearea.vue?vue&type=template&id=a4a1e530&scoped=true"
import script from "./Notearea.vue?vue&type=script&lang=js"
export * from "./Notearea.vue?vue&type=script&lang=js"
import style0 from "./Notearea.vue?vue&type=style&index=0&id=a4a1e530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a1e530",
  null
  
)

export default component.exports